import React from "react";
import { pluralise } from "repoV2/features/Common/utils/strings";
import { IClassDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import useSingleSession from "./SingleSession.utils";
import styles from "./SingleSession.module.scss";

const SingleSession = (props: { classes: IClassDetails[] }) => {
    const { classes } = props;

    const { renderSchedultType, renderStartingDate, groupedSlots } =
        useSingleSession(classes);

    return (
        <div>
            <div className={styles.subTextStyles}>
                <span>{renderSchedultType}</span> |{" "}
                <span>Starts on {renderStartingDate}</span>
            </div>
            <div className={styles.dateContainer}>
                {groupedSlots.map(slotValue => (
                    <div key={`${slotValue.day}=${slotValue.time}`}>
                        <span className={styles.dayStyles}>
                            {pluralise(slotValue.day, 2)}
                        </span>{" "}
                        <span>-</span>{" "}
                        <span className={styles.dateStyles}>
                            {slotValue.time.join(", ")}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SingleSession;
